// src/components/Character.js
import React, { useEffect, useRef, useState } from 'react';
import './Character.css';

const Character = ({ characterStyle, lowContrast, onChooseCharacter }) => {
  const canvasRef = useRef(null);
  const [currentFrameIndex, setCurrentFrameIndex] = useState(0);
  
  const frameCount = 11;
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const frameWidth = 1280;
  const frameHeight = 1920;
  const columns = 5;
  const spriteSrc = `/characters/${characterStyle}/${characterStyle}sprite.png`;

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const image = new Image();
    image.src = spriteSrc;

    image.onload = () => {
      drawFrame(context, image, currentFrameIndex);
    };
  }, [currentFrameIndex, spriteSrc]);

  const drawFrame = (context, image, index) => {
    const col = index % columns;
    const row = Math.floor(index / columns);
    const x = col * frameWidth;
    const y = row * frameHeight;

    context.clearRect(0, 0, frameWidth, frameHeight);
    context.drawImage(image, x, y, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setStartX(e.touches[0].clientX);
  };

  const handleMouseMove = (e) => {
    e.preventDefault();
    if (isDragging) {
      const deltaX = e.clientX - startX;
      if (deltaX > 10) {
        setCurrentFrameIndex((prevIndex) => (prevIndex + 1) % frameCount);
        setStartX(e.clientX);
      } else if (deltaX < -10) {
        setCurrentFrameIndex((prevIndex) => (prevIndex - 1 + frameCount) % frameCount);
        setStartX(e.clientX);
      }
    }
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
    if (isDragging) {
      const deltaX = e.touches[0].clientX - startX;
      if (deltaX > 10) {
        setCurrentFrameIndex((prevIndex) => (prevIndex + 1) % frameCount);
        setStartX(e.touches[0].clientX);
      } else if (deltaX < -10) {
        setCurrentFrameIndex((prevIndex) => (prevIndex - 1 + frameCount) % frameCount);
        setStartX(e.touches[0].clientX);
      }
    }
  };

  const handleMouseUp = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleTouchEnd = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleRotateLeft = () => {
    setCurrentFrameIndex((prevIndex) => (prevIndex - 1 + frameCount) % frameCount);
  };

  const handleRotateRight = () => {
    setCurrentFrameIndex((prevIndex) => (prevIndex + 1) % frameCount);
  };

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchmove', handleTouchMove);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleMouseMove, handleTouchMove]);

  return (
    <div id="character-container">
      <canvas
        ref={canvasRef}
        width={frameWidth}
        height={frameHeight}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      />
      <div id="character-buttons">
        <button id="rotate-left" className={`rotate-left ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} onClick={handleRotateLeft} onTouchStart={handleRotateLeft}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-rotate-cw">
            <polyline points="23 4 23 10 17 10"></polyline>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
          </svg>
        </button>
        <button id="rotate-right" className={`rotate-right ${lowContrast ? 'low-contrast' : 'normal-contrast'}`} onClick={handleRotateRight} onTouchStart={handleRotateRight}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-rotate-ccw">
            <polyline points="1 4 1 10 7 10"></polyline>
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Character;
